import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { useRootSelector } from "../stateSelectors.js";
import { closeSpecificViewOption, selectedViewOptionSelector, setSelectedViewOption, toggleSelectedViewOption, } from "../slices/commonSlice.js";
export const useViewOptionSelected = (path) => {
    const dispatch = useDispatch();
    const selected = useRootSelector((state) => selectedViewOptionSelector(state) === path);
    const toggleViewOption = useCallback(() => {
        dispatch(toggleSelectedViewOption(path));
    }, [dispatch, path]);
    const closeViewOption = useCallback(() => {
        dispatch(closeSpecificViewOption(path));
    }, [dispatch, path]);
    const openViewOption = useCallback(() => {
        dispatch(setSelectedViewOption(path));
    }, [dispatch, path]);
    return { selected, toggleViewOption, closeViewOption, openViewOption };
};
//# sourceMappingURL=useViewOptionSelected.js.map